import {useCallback, useSyncExternalStore} from 'react'
import type {AhpDebugEvent} from '@github-ui/copilot-shared-ui/utils/ahp-debug-log'

import {getAhpDebugLogSnapshot, subscribeToAhpDebugLog} from '../ahp/ahp-debug-log'

const EMPTY_DEBUG_EVENTS: readonly AhpDebugEvent[] = []

/** Subscribes to the AHP relay debug log recorded for the given task. */
export function useAhpDebugEvents(taskId: string | undefined): readonly AhpDebugEvent[] {
  const subscribe = useCallback((listener: () => void) => subscribeToAhpDebugLog(taskId, listener), [taskId])
  const getSnapshot = useCallback(() => getAhpDebugLogSnapshot(taskId), [taskId])

  return useSyncExternalStore(subscribe, getSnapshot, () => EMPTY_DEBUG_EVENTS)
}
